import React, { useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { ATMModal } from '../../atoms/ATMModal/ATMModal.component';
import { ATMButton } from '../../atoms/ATMButton/ATMButton.component';
import styles from './MOLIdleTime.module.scss';
import { MOLCountDown } from './MOLCountDown.component';
import { useNavigate } from 'react-router-dom';

export type IMOLIdleProps = {
  timeout: number;
  onContinue?: () => void;
};

const MOLIdleTime: React.FC<IMOLIdleProps> = ({ timeout, ...props }) => {
  const [idle, setIdle] = useState(false);
  
  // Validate timeout value
  const timeoutMs = React.useMemo(() => {
    const validTimeout = timeout && !isNaN(timeout) && timeout > 0 ? timeout : parseInt(process.env.REACT_APP_IDLE_TIMEOUT_MINUTES || '25', 10);
    const ms = validTimeout * 60 * 1000;
    return ms;
  }, [timeout]);

  const handleOnIdle = () => {
    setIdle(true);
  };

  const navigateTo = useNavigate();
  const renderer = ({ minutes, seconds, completed }: any) => {
    if (completed) {
      setIdle(false);
      navigateTo('/');
    }
    // Render a countdown
    return (
      <div>
        <div className={styles.timerText}>
          Do you wish to continue your current session?
        </div>
        <div>
          Application will be refreshed in
          <span className={styles.timeDisplay}>
            {minutes}:{seconds <= 9 ? 0 : null}
            {seconds}
          </span>
        </div>
      </div>
    );
  };

  useIdleTimer({
    timeout: timeoutMs,
    onIdle: handleOnIdle,
    debounce: 500,
    crossTab: true,
    syncTimers: 200,
  });

  const handleonContinue = () => {
    setIdle(false);
  };

  const handleOnClose = () => {
    setIdle(false);
    navigateTo('/');
  };

  const time = new Date();

  return idle ? (
    <ATMModal
      closeOnDimmerClick={false}
      onClose={() => setIdle(false)}
      open={idle}
      size="tiny"
    >
      <ATMModal.Header>Idle Session Warning</ATMModal.Header>
      <ATMModal.Content>
        <MOLCountDown
          date={time.setSeconds(time.getSeconds() + 300)}
          renderer={renderer}
        />
      </ATMModal.Content>
      <ATMModal.Actions>
        <ATMButton secondary onClick={() => handleOnClose()}>
          Close
        </ATMButton>
        <ATMButton primary onClick={() => handleonContinue()}>
          Yes, Continue
        </ATMButton>
      </ATMModal.Actions>
    </ATMModal>
  ) : null;
};

export { MOLIdleTime };
